import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEye, faTrash,faDownload } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { Box, Button, CircularProgress, MenuItem, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { useNavigate, useParams } from 'react-router-dom';

import { IoArrowBack } from "react-icons/io5";

import { useState ,useEffect, useMemo } from "react";

import TablePaginationActions from '../../../../base-components/TablePaginationActions';
import ExportDropdownMenu from '../../../../base-components/ExportDropdownMenu';
import { Pie } from 'react-chartjs-2';
import { Report } from './Report';
import dayjs from 'dayjs';
import FeeCollectionStatsModal from './StatsModal';
import BarChartIcon from '@mui/icons-material/BarChart';
import { matchesBankGlFilter, uniqueBankGlOptions, withFeeCollectionExtraFields } from './feeCollectionReportFields';
import { isDynamicStaffRole } from '../../../../utils/roleAccess';
import { PageHeader } from "../../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;
function FeeCollectionReport() {
    const navigate = useNavigate()
    //states for this page
    const [loading , setLoading] = useState(false)
    const [vouchers , setVouchers] = useState([])
    //roles and permission states
    const [role , setRole] = useState('')
    const [location_id , setLocationID] = useState('')
    const [company_id , setCompanyID] = useState('')
    const [member_id , setMemberID] = useState('')
    //pagintion states
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page , setPage ] = useState(0)
    const [filtered_vouchers, setFilteredVouchers] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [status, setStatus] = useState("");
    
    const [VoucherType, setSubscriptionType] = useState("");
    const [paymentFromDate, setPaymentFromDate] = useState(""); 
    const [paymentToDate, setPaymentToDate] = useState("");  
    const [dueFromDate, setDueFromDate] = useState("");
    const [dueToDate, setDueToDate] = useState("");
    const [searchQuery, setSearchQuery] = useState(""); 
    const [totalRecieved , setTotalRecieved] = useState(0)
    const [totalDiscount , setTotalDiscount] = useState(0)
    const[gender,setGender]=useState("")
    const [memberStatus, setMemberStatus] = useState("none");
    const [payment_method, setPaymentMethod] = useState("All");
    const [bankGlFilter, setBankGlFilter] = useState("All");
    const [bankAccounts, setBankAccounts] = useState([]);
    const [hasBankIntegration, setHasBankIntegration] = useState(false);

    // Modal states
    const [openStatsModal, setOpenStatsModal] = useState(false);


    useEffect(()=> {
        const sessionStr = sessionStorage.getItem('user-info');
        if(sessionStr){
            const session = JSON.parse(sessionStr);
            setRole(session.user.role)
            setCompanyID(session.user.company_id)
            setLocationID(session.user.location_id)
            setMemberID(session.user.member_id)
            setHasBankIntegration(session.user.company?.has_bank_integration || false)
        }
        else {
            navigate('/login');
        }
    },[])

    // useEffect(() => {
    //     setLoading(true)
    //     if(role) {
    //     getVouchers()
    //     setTimeout(()=> {
    //         setLoading(false)
    //     } , 1000)
    //     }
    // }, [role]);

      useEffect(() => {
          const fetchVouchers = async () => {
            setLoading(true);
            if (role) {
              await getVouchers(); 
              setLoading(false);       
            } 
          };
        
          fetchVouchers();
        }, [role]);

    useEffect(() => {
        if (!hasBankIntegration || !company_id) {
            setBankAccounts([]);
            return;
        }
        fetch(`${BASE_URL}company-bank-accounts/company/${company_id}`)
            .then((response) => response.json())
            .then((data) => {
                setBankAccounts(data.bankAccounts || []);
            })
            .catch((error) => {
                console.log(error);
                setBankAccounts([]);
            });
    }, [hasBankIntegration, company_id]);

    const bankGlOptions = useMemo(
        () => uniqueBankGlOptions(vouchers, bankAccounts),
        [vouchers, bankAccounts]
    );

    const showBankGlFilter = hasBankIntegration || bankGlOptions.length > 0;

    const getVouchers = async () => {
        if(!role) return;
        let endpoint = '';
        console.log(role);
        if (role === 'SuperAdmin') {
            endpoint = ``;
        } else if (role === 'Admin') {
            endpoint = `voucher/getVouchersByCompanyID/${company_id}`;
        } else if (role === 'ClubAdmin') {
            endpoint = `voucher/getAllVouchersByLocationID/${location_id}`;
        } else if (isDynamicStaffRole(role)) {
            endpoint = `voucher/getAllVouchersByLocationID/${location_id}`;
        }
        await fetch(BASE_URL + endpoint)
        .then((response) => response.json())
        .then((data) => {
            const allVouchers = data.vouchers;
            const paidVouchers = allVouchers.filter(voucher => voucher?.invoice?.payment_status === 'Paid' || voucher?.receipt )
            setVouchers(paidVouchers)
            setFilteredVouchers(paidVouchers)
            const recieved = paidVouchers.reduce((sum, voucher) => sum + (voucher.paid_amount || 0), 0);
            const discount = paidVouchers.reduce((sum, voucher) => sum + (voucher.invoice?.discount || 0), 0);
            console.log('recieved: ' , recieved);
            console.log('discount: ' , discount);
            
            setTotalRecieved(recieved)
            setTotalDiscount(discount)
            // setVoucherStats({
            //     labels: ["Total Recieved Amount", "Total Discount Amount"],
            //     datasets: [
            //       {
            //         data: [totalRecieved, totalDiscount],
            //         backgroundColor: ["#4CAF50", "#FF5733"],
            //       },
            //     ],
            //   });
        })
        .catch((error) => {
            console.log(error)
        });
    }
    const paginatedVouchers = !filtered_vouchers || filtered_vouchers.length === 0 ?
    [] :
     rowsPerPage === -1
    ? filtered_vouchers // Show all if "All" option is selected
    : filtered_vouchers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
      
      // Export handlers
      const handleExportAll = () => {
          Report(vouchers, hasBankIntegration);
      };
      
      const handleExportWithFilters = () => {
          Report(filtered_vouchers, hasBankIntegration);
      };
      
      const handleExportCurrentView = () => {
          Report(paginatedVouchers, hasBankIntegration);
      };
      
      const handleDownload=()=>{
          Report(filtered_vouchers, hasBankIntegration)
      }
      
      // Check if filters are applied
      const hasFiltersApplied = useMemo(() => {
          return !!(fromDate || toDate || VoucherType || paymentFromDate || paymentToDate || 
                    dueFromDate || dueToDate || searchQuery || gender || memberStatus !== "none" || 
                    payment_method !== "All" || bankGlFilter !== "All");
      }, [fromDate, toDate, VoucherType, paymentFromDate, paymentToDate, dueFromDate, dueToDate, 
          searchQuery, gender, memberStatus, payment_method, bankGlFilter]);
      
            const handleSearch = (search) => {
                  setSearchQuery(search);
                  let filteredvoucher = [];
                  if(search === '') {
                    setFilteredVouchers(vouchers);
                  }
                  else {
                    filteredvoucher  = vouchers.filter((voch) => {
                        const combinedMemberID = `${voch?.location_id?.member_id_temp}${voch?.member_id?.member_id}`.toLowerCase();
                        const extra = withFeeCollectionExtraFields(voch);
                        const q = search.toLowerCase();
                        return (
                            (voch.invoice_no.toLowerCase()?.includes(q)) || 
                            (voch.voucher_type.toLowerCase()?.includes(q)) ||
                            (combinedMemberID?.includes(q)) ||
                            (voch.member_id.name.toLowerCase()?.includes(q)) ||
                            (extra.package_name.toLowerCase().includes(q)) ||
                            (extra.trainer_name.toLowerCase().includes(q)) ||
                            (extra.voucher_complete_head.toLowerCase().includes(q)) ||
                            ((voch.bank_gl || '').toLowerCase().includes(q))
                        )
                    });
                    setFilteredVouchers(filteredvoucher);
                  }
              }; 

   
  
    const handleFilter = () => {
        setLoading(true);
        let filtered = vouchers; 
        console.log(filtered);
    
        if (fromDate && toDate) {
            const startFilterDate = new Date(fromDate);
            startFilterDate.setHours(0, 0, 0, 0);

            const endFilterDate = new Date(toDate);
            endFilterDate.setHours(23, 59, 59, 999);

            console.log("startFilterDate : ",startFilterDate);
            console.log("endFilterDate : ",endFilterDate);
            filtered = filtered.filter(voucher => {
                const voucherDate = new Date(voucher?.invoice?.payment_date || voucher?.receipt?.created_at);
                console.log(voucherDate >= startFilterDate && voucherDate <= endFilterDate);
                return voucherDate >= startFilterDate && voucherDate <= endFilterDate;
            });
        }
      
        if(memberStatus){
            if(memberStatus === 'active'){
                filtered = filtered.filter(voucher => 
                    voucher.member_id.is_active === true
                );
            }else if(memberStatus === 'inactive'){
                filtered = filtered.filter(voucher => 
                    voucher.member_id.is_active === false
                );
            }else if(memberStatus === 'new'){
                filtered = filtered.filter(voucher => 
                    voucher.member_id.is_new === true
                );
            }else if(memberStatus === 'restored'){
                filtered = filtered.filter(voucher => 
                    voucher.member_id.is_restored === true
                );
            }else if(memberStatus === 'male'){
                filtered = filtered.filter(voucher => 
                    voucher.member_id.gender === 'male'
                );
            }else if(memberStatus === 'female'){
                filtered = filtered.filter(voucher => 
                    voucher.member_id.gender === 'female'
                );
            }else if(memberStatus === 'trainer'){
              filtered = filtered.filter(voucher => 
                voucher.invoice && 
                voucher.invoice.trainer_fee != null && 
                voucher.invoice.trainer_fee > 0
              );
            }else if(memberStatus === 'no_trainer'){
              filtered = filtered.filter(voucher => 
                voucher.invoice && 
                voucher.invoice.trainer_fee != null && 
                voucher.invoice.trainer_fee === 0
              );
            }

        }

        if(payment_method){
            if(payment_method === 'Cash'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Cash'
              );
            }else if(payment_method === 'Cheque'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Cheque'
              );
            }else if(payment_method === 'Online'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Online'
              );
            }else if(payment_method === 'Jazzcash'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Jazzcash'
              );
            }else if(payment_method === 'Card'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Card'
              );
            }else if(payment_method === 'Wallet'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Wallet'
              );
            }else if(payment_method === 'Other'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Other'
              );
            }else if(payment_method === 'Bank'){
              filtered = filtered.filter(voucher => 
                  voucher.payment_method === 'Bank'
              );
            }
        }

        filtered = filtered.filter((voucher) => matchesBankGlFilter(voucher, bankGlFilter));
    
        console.log("Filtered Vouchers:", filtered);
        setFilteredVouchers(filtered);
        
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    // const filterVouchers = (value) => {
    //     setMemberStatus(value)
    //     console.log('value: ' , value);
        
    //     let FilteredVouchers;
    //       switch (value) {
    //         case "active":
    //           FilteredVouchers = vouchers.filter((voucher) => voucher.member_id.is_active === true);
    //         case "restored":
    //           FilteredVouchers = vouchers.filter((voucher) => voucher.member_id.is_restored === true);
    //         case "none":
    //           FilteredVouchers = vouchers
    //         case "new":
    //           FilteredVouchers = vouchers.filter((voucher) => voucher.member_id.is_new === true);
    //         case "inactive":
    //           FilteredVouchers = vouchers.filter((voucher) => voucher.member_id.is_active === false);
    //         case "male":
    //           FilteredVouchers = vouchers.filter((voucher) => voucher.member_id.gender === 'male');
    //         case "female":
    //           FilteredVouchers = vouchers.filter((voucher) => voucher.member_id.gender === 'female');
    //         default:
    //           FilteredVouchers = vouchers.filter((voucher) => voucher.member_id.is_active === false);
    //         //   FilteredVouchers = vouchers
    //       }
    //       console.log("FilteredVouchers: " , FilteredVouchers);
          
    //       setFilteredVouchers(FilteredVouchers)
    //   };

      const handleStatusChange = (value) => {
        setMemberStatus(value);
        
    }
  
      
    
      const handleClear = () => {
        setLoading(true); 
        setFilteredVouchers(vouchers); 
    
        
        setFromDate("");
        setToDate("");
        setStatus("");
       
        setSubscriptionType("");
        setDueFromDate("");
        setDueToDate("");
        setPaymentFromDate("");
        setPaymentToDate("");
        setPaymentMethod("All");
        setBankGlFilter("All");
        setMemberStatus("none");
    
        
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      };
  return (
    <>
    <div className='flex items-center justify-end my-2 mx-3'>
      <ExportDropdownMenu
        onExportAll={handleExportAll}
        onExportWithFilters={handleExportWithFilters}
        onExportCurrentView={handleExportCurrentView}
        hasFilters={hasFiltersApplied}
        className='text-blue-800 hover:cursor-pointer hover:text-blue-900'
      />
    </div>
<div className="m-5 print:hidden"><PageHeader title="Fee Collection Report" /></div>
<div className="w-[93%] my-3 mx-2 md:mx-8 relative">
  <input
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => handleSearch(e.target.value)}
    className="border border-gx-border rounded-md py-1 px-2 pl-10 outline-0 w-full md:w-72"
  />
  <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-2 text-gx-ink-soft" />
</div>
<div className='flex items-center justify-between my-3 md:mx-8'>
<Button variant="contained"
  color="primary"
  startIcon={<BarChartIcon />}
  className="bg-gx-red hover:bg-[#ff0008] text-white font-bold rounded-lg relative overflow-hidden"  
  onClick={() => setOpenStatsModal(true)}
  >
  View Stats
</Button>
</div>
<div className='flex flex-col lg:flex-row items-start lg:items-center justify-start gap-4 lg:gap-16 px-2 md:px-0'>
  {/* <div className='mx-2 md:mx-10 w-full md:w-auto'>
    <div className='flex justify-between md:justify-start items-center gap-5'>
      <div className='text-gx-red font-bold'>Total Invoices:</div>
      <div className='font-semibold'>{filtered_vouchers.length}</div>
    </div>
    <div className='flex justify-between md:justify-start items-center gap-5'>
      <div className='text-[#F7931E] font-bold'>Total Amount:</div>
      <div className='font-semibold'>{filtered_vouchers.reduce((sum, voucher) => sum + (voucher.paid_amount || 0), 0)}</div>
    </div>
  </div> */}
  <div className="w-full md:w-auto md:mx-8">
    <form onSubmit={(e) => e.preventDefault()} className="flex flex-col gap-2 md:gap-4">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 lg:gap-8">
        <div className="flex items-center gap-2 w-full md:w-auto">
          <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">From Date:</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="border border-gx-border rounded-md py-1 px-3 outline-0 text-gx-ink-soft w-full md:w-48"
          />
        </div>
      
        <div className="flex items-center gap-2 w-full md:w-auto">
          <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">End Date:</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            disabled={!fromDate} 
            min={fromDate}
            className="border border-gx-border rounded-md py-1 px-3 outline-0 w-full md:w-48"
          />
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 w-full">
        <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">Select Payment Method</label>
        <Select className='w-full md:w-[200px] bg-white h-9' value={payment_method}
          onChange={(e) => setPaymentMethod(e.target.value)}
        >
          <MenuItem value='All'>All Methods</MenuItem>
          <MenuItem value='Cash'>Cash</MenuItem>
          <MenuItem value='Cheque'>Cheque</MenuItem>
          <MenuItem value='Online'>Online Transfer</MenuItem>
          <MenuItem value='Jazzcash'>Jazzcash</MenuItem>
          <MenuItem value='Card'>Card</MenuItem>
          <MenuItem value='Wallet'>Wallet</MenuItem>
          <MenuItem value='Other'>Other</MenuItem>
          {hasBankIntegration && (
            <MenuItem value='Bank'>Bank</MenuItem>
          )}
        </Select>
        {showBankGlFilter && (
          <>
            <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">Select Bank GL</label>
            <Select className='w-full md:w-[200px] bg-white h-9' value={bankGlFilter}
              onChange={(e) => setBankGlFilter(e.target.value)}
            >
              <MenuItem value='All'>All Bank GLs</MenuItem>
              <MenuItem value='none'>No Bank GL</MenuItem>
              {bankGlOptions.map((gl) => (
                <MenuItem key={gl} value={gl}>{gl}</MenuItem>
              ))}
            </Select>
          </>
        )}
        <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">Select Filter</label>
        <Select className='w-full md:w-[200px] bg-white h-9' value={memberStatus}
          onChange={(e) => setMemberStatus(e.target.value)}
        >
          <MenuItem value='none'>None</MenuItem>
          <MenuItem value='active'>Active Members</MenuItem>
          <MenuItem value='inactive'>Inactive Members</MenuItem>
          <MenuItem value='new'>New Members</MenuItem>
          <MenuItem value='restored'>Re Activated Members</MenuItem>
          <MenuItem value='male'>Male</MenuItem>
          <MenuItem value='female'>Female</MenuItem>
          <MenuItem value='trainer'>Personal Trainer</MenuItem>
          <MenuItem value='no_trainer'>No Personal Trainer</MenuItem>
        </Select>
        <div className='w-full md:w-auto'>
          <button onClick={handleFilter} className="bg-green-700 text-white hover:bg-green-800 py-1 px-4 rounded-md flex items-center justify-center gap-4 w-full md:w-auto mt-2 md:mt-0">
            Fetch Invoices
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
        
        
        {
            loading ? (
               
                 <div className="flex justify-center items-center mt-20 relative">
                   {/* SVG Gradient Definition */}
                   <svg width="0" height="0">
                     <defs>
                       <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                         <stop offset="0%" stopColor="#D71920" />
                         <stop offset="100%" stopColor="#F7931E" />
                       </linearGradient>
                     </defs>
                   </svg>
           
                   {/* Circular Progress with Gradient Stroke */}
                   <CircularProgress
                     thickness={4}
                     size={35}
                     sx={{
                       'svg circle': {
                         stroke: 'url(#gradientColors)', // Apply gradient stroke
                       },
                     }}
                   />
                 </div>
               
             ) : (
                filtered_vouchers && filtered_vouchers.length !== 0 ? (     
            <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto  overflow-x-auto">
                <Table>
                  <TableHead>
                      <TableRow >
                          <TableCell>Voucher No</TableCell>
                          <TableCell>Member Id</TableCell>
                          <TableCell>Member Name</TableCell>
                          <TableCell>Package Name</TableCell>
                          <TableCell>Trainer Name</TableCell>
                          <TableCell>Gender</TableCell>
                          <TableCell>Phone Number</TableCell>
                          <TableCell>Issue Date</TableCell>
                          <TableCell>Due Date</TableCell>
                          <TableCell>Paid Date</TableCell>
                          <TableCell>Voucher Complete Head</TableCell>
                          <TableCell>Gross Amount</TableCell>
                          <TableCell>Discount Amount</TableCell>
                          <TableCell>Net Amount</TableCell>
                          <TableCell>Due Amount</TableCell>
                          <TableCell>Voucher Type</TableCell>
                          <TableCell>Payment Method</TableCell>
                          <TableCell>Payment Reference</TableCell>
                          {hasBankIntegration && (
                            <TableCell>Bank GL</TableCell>
                          )}
                          <TableCell>Trainer Fee</TableCell>
                          <TableCell>Member Status</TableCell>
                          <TableCell>Paid Amount</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Actions</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      paginatedVouchers.map((voucher , index) => {
                        const extra = withFeeCollectionExtraFields(voucher);
                        return (
                            voucher?.voucher_type === 'Invoice' ?
                                (<TableRow hover key={index}>
                                    <TableCell>{voucher?.invoice_no}</TableCell>
                                    <TableCell>{voucher?.location_id?.member_id_temp + voucher?.member_id.member_id}</TableCell>
                                    <TableCell>{voucher?.member_id.name}</TableCell>
                                    <TableCell>{extra.package_name}</TableCell>
                                    <TableCell>{extra.trainer_name}</TableCell>
                                    <TableCell>{voucher?.member_id.gender}</TableCell>
                                    <TableCell>{voucher?.member_id.phone}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher.voucher_date).format('MMM DD, YYYY') : ''}</TableCell>
                                    <TableCell>{voucher?.invoice?.due_date ? dayjs(voucher.invoice.due_date).format('MMM DD, YYYY')  : ''}</TableCell>
                                    <TableCell>{voucher?.invoice?.payment_date ? dayjs(voucher?.invoice?.payment_date).format('MMM DD, YYYY')  : ''}</TableCell>
                                    <TableCell>{extra.voucher_complete_head}</TableCell>
                                    <TableCell>Rs {extra.gross_amount}</TableCell>
                                    <TableCell>Rs {extra.discount_amount}</TableCell>
                                    <TableCell>Rs {extra.net_amount}</TableCell>
                                    <TableCell>Rs {voucher?.invoice?.total_amount}</TableCell>
                                    <TableCell>{voucher?.voucher_type || 0}</TableCell>
                                    <TableCell>{voucher?.payment_method}</TableCell>
                                    <TableCell>{voucher?.reference_number || '—'}</TableCell>
                                    {hasBankIntegration && (
                                      <TableCell>{voucher?.bank_gl || '—'}</TableCell>
                                    )}
                                    <TableCell>Rs {voucher?.invoice?.trainer_fee}</TableCell>
                                    <TableCell>{voucher?.invoice?.trainer_fee === 0 || voucher?.invoice?.trainer_fee === null? 'General' : 'Trainer'}</TableCell>
                                    <TableCell>Rs {voucher?.paid_amount || 0}</TableCell>
                                    <TableCell>{voucher?.invoice?.payment_status || 'Expired'}</TableCell>
                                    <TableCell>
                                        <div className='flex gap-2'>
                                            <div className='flex items-center justify-center gap-2'>
                                                <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/voucher/${voucher?._id}`)}>
                                                    <FontAwesomeIcon icon={faEye}/> View
                                                </div>
                                                {/* <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/transactions?voucher_id=${voucher?._id}`)}>
                                                    {'Transactions>>'}
                                                </div> */}
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>) : (
                                    voucher?.voucher_type === 'Receipt' ? 
                                    (<TableRow>
                                    <TableCell>{voucher?.invoice_no}</TableCell>
                                    <TableCell>{voucher?.location_id?.member_id_temp + voucher?.member_id.member_id}</TableCell>
                                    <TableCell>{voucher?.member_id.name}</TableCell>
                                    <TableCell>{extra.package_name}</TableCell>
                                    <TableCell>{extra.trainer_name}</TableCell>
                                    <TableCell>{voucher?.member_id.gender}</TableCell>
                                    <TableCell>{voucher?.member_id.phone}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format('MMM DD, YYYY') 
                                    : ''}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format('MMM DD, YYYY') 
                                    : ''}</TableCell>
                                    <TableCell>{voucher?.voucher_date ? dayjs(voucher?.voucher_date).format('MMM DD, YYYY') 
                                    : ''}</TableCell>
                                    <TableCell>{extra.voucher_complete_head}</TableCell>
                                    <TableCell>Rs {extra.gross_amount}</TableCell>
                                    <TableCell>Rs {extra.discount_amount}</TableCell>
                                    <TableCell>Rs {extra.net_amount}</TableCell>
                                    <TableCell>Rs {voucher?.paid_amount || '- - - '}</TableCell>
                                    <TableCell>{voucher?.voucher_type || 0}</TableCell>
                                    <TableCell>{voucher?.payment_method}</TableCell>
                                    <TableCell>{voucher?.reference_number || '—'}</TableCell>
                                    {hasBankIntegration && (
                                      <TableCell>{voucher?.bank_gl || '—'}</TableCell>
                                    )}
                                    <TableCell>Rs {0}</TableCell>
                                    <TableCell>General</TableCell>
                                    <TableCell>Rs {voucher?.paid_amount || 0}</TableCell>
                                    <TableCell>Paid</TableCell>
                                    <TableCell>
                                        <div className='flex gap-2'>
                                            <div className='flex items-center justify-center gap-2'>
                                                <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/recipt/${voucher?._id}`)}>
                                                    <FontAwesomeIcon icon={faEye}/> View
                                                </div>
                                                {/* <div className='text-gx-ink font-bold hover:cursor-pointer hover:text-green-700' onClick={()=> navigate(`/transactions?voucher_id=${voucher?._id}`)}>
                                                    {'Transactions>>'}
                                                </div> */}
                                            </div>
                                        </div>
                                    </TableCell>
                                    </TableRow>): null
                                )
                        );
                      })
                    }
                  </TableBody>
                  <TableFooter>
                      <TableRow>
                      <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          colSpan={hasBankIntegration ? 24 : 23}
                          count= {filtered_vouchers.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          slotProps={{
                              select: {
                              inputProps: {
                                  'aria-label': 'rows per page',
                              },
                              native: true,
                              },
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                          />
                      </TableRow>
                  </TableFooter>
              </Table>
            </Box>
            ) : (
              <div className='bg-gx-border w-ful p-3 mt-10 rounded-lg m-10'>
                <h3 className='text-xl font-bold text-center text-gx-ink-soft'>No Records Found</h3>
              </div>
            )
        )
          }
          <FeeCollectionStatsModal
            filtered_vouchers={filtered_vouchers}
            open={openStatsModal}
            setOpen={setOpenStatsModal}
          />
    </>
  )
}

export default FeeCollectionReport